import { DEFAULT_APP_SLUG } from "../config";
import { getRole, ROLES } from "./roles";

const RESERVED_PATHS = new Set([
  "dashboard",
  "users",
  "events",
  "stats",
  "error",
  "verify",
  "resetpassword",
  "requestreset",
  "about",
  "course",
  "login",
  "register",
  "ottieni",
  "privacy-policy",
  "cookie-policy",
]);

export function extractAppSlugFromPath(pathname) {
  const parts = pathname.split("/").filter(Boolean);
  if (!parts.length) return null;
  if (RESERVED_PATHS.has(parts[0])) return null;
  return parts[0];
}

export function getRememberedAppSlug() {
  try {
    const slug = localStorage.getItem("lastAppSlug");
    if (!slug || RESERVED_PATHS.has(slug)) return null;
    return slug;
  } catch {
    return null;
  }
}

export function resolveAppSlug(pathname, loginStatus) {
  const fromPath = extractAppSlugFromPath(pathname);
  if (fromPath) return fromPath;
  if (pathname.startsWith("/dashboard")) {
    const role = getRole(loginStatus);
    if (role === ROLES.ADMIN || role === ROLES.SUPERADMIN) return null;
    return loginStatus?.application_slug || getRememberedAppSlug() || null;
  }
  return null;
}

export function rememberAppSlug(slug) {
  if (slug) localStorage.setItem("lastAppSlug", slug);
}

export function appPath(slug, subPath = "") {
  if (!slug) {
    const clean = subPath.startsWith("/") ? subPath.slice(1) : subPath;
    return clean ? `/${clean}` : "/";
  }
  const clean = subPath.startsWith("/") ? subPath.slice(1) : subPath;
  return clean ? `/${slug}/${clean}` : `/${slug}`;
}

export function mainSitePath() {
  return "/";
}

export function visitSitePath(loginStatus) {
  const role = getRole(loginStatus);
  if (role === ROLES.ADMIN || role === ROLES.SUPERADMIN) {
    return "/";
  }
  const slug = loginStatus?.application_slug || getRememberedAppSlug();
  if (slug) {
    return appPath(slug);
  }
  return "/";
}

export { DEFAULT_APP_SLUG };
